// useLinepros1.js
import { useMemo } from "react";

const lpActions = {
    showLogin: () => window.parent.postMessage({ "banner-click": { action: "show-login" } }, "*"),
    showJoin: () => window.parent.postMessage({ "banner-click": { action: "show-join" } }, "*"),
    showDeposits: () => window.parent.postMessage({ "banner-click": { action: "show-deposits" } }, "*"),
    showPayouts: () => window.parent.postMessage({ "banner-click": { action: "show-payouts" } }, "*"),
    showSports: () =>
        window.parent.postMessage({ "banner-click": { action: "show-sport", params: { partnerProduct: "prematch" } } }, "*"),
    showLiveBetting: () =>
        window.parent.postMessage({ "banner-click": { action: "show-sport", params: { partnerProduct: "live" } } }, "*")
};

// export const useLinepros1 = () => {
//     const trackHeight = () => {
//         setTimeout(() => {
//             const newHeight = document.body.scrollHeight;
//             window.parent.postMessage({ "full-content-height": newHeight }, "*");
//             console.log("📏 Enviando altura después de render:", newHeight);
//         }, 600);
//     };
//
//     return useMemo(
//         () => ({
//             trackHeight,
//             actions: lpActions
//         }),
//         []
//     );
// };

export const useLinepros1 = () => {
    const trackHeight = () => {
        const sendHeight = () => {
            const newHeight = document.body.scrollHeight;
            window.parent.postMessage({ "full-content-height": newHeight }, "*");
        };

        setTimeout(sendHeight, 500);

        const observer = new MutationObserver(sendHeight);
        observer.observe(document.body, { childList: true, subtree: true });
    };

    return useMemo(() => ({
        trackHeight,
        actions: lpActions
    }), []);
};
